import { lazy } from 'react';

export const InlineNumberInput = lazy(() => import('src/components/FormRenderers/InlineNumberInput/InlineNumberInput'));
